import React, { createContext, useContext, useState, useEffect } from "react";

const StatusContext = createContext();

export const StatusProvider = ({ children }) => {
  const [statusValues, setstatusValues] = useState({
    dashboardReady: localStorage.getItem('dashboard-ready'),
    minDate: localStorage.getItem('min_date'),
    maxDate: localStorage.getItem('max_date'),
    showAds: localStorage.getItem('show-ads'),
    maxSettlementAt:'',
    maxPurchaseAt:'',
    message:''
  });

  return (
    <StatusContext.Provider value={{ statusValues, setstatusValues }}>
      {children}
    </StatusContext.Provider>
  );
};

export const useStatus = () => useContext(StatusContext);
